import { Component } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-seo-off-page-prospects-list',
  templateUrl: './seo-off-page-prospects-list.component.html',
  styleUrls: ['./seo-off-page-prospects-list.component.css'],
})
export class SeoOffPageProspectsListComponent {
  url: string = 'seoOffpageProspects';
  data: Array<any> = [];
  searchText = '';
  filteredData: Array<any> = [];
  searchSuggestions: string[] = [];
  currentPage: number = 1;
  morePages: boolean = true;
  itemsPerPage: number = 50;
  modalTitle: string = '';
  modalContent: string | null = null;

  resumenCards = [
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'SEO',
      route: '/marketing',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'ADS',
      route: '/marketing/ads',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-people-line',
      bgClass: 'bg-white',
      desc: 'SOCIAL',
      route: '/marketing/social/strategy',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'GEO',
      route: '',
    },
    
  ];

  constructor(
    private dataService: DataService,
    private messageService: MessageService,
  ) {}

  ngOnInit(): void {
    this.getData();
  }

  getData(): void {
    this.dataService
      .getDataTwo(this.url, '', '', this.currentPage, this.itemsPerPage)
      .subscribe((response) => {
        if (response.data) {
          this.data = response.data.sort((a: any, b: any) => {
            return (
              new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
            );
          });
          this.filteredData = [...this.data];
          this.updateSuggestions();
        }
      });
  }

  markContacted(id: string): void {
    if (!confirm('¿Desea marcar este prospecto como contactado?')) {
      return;
    }
    this.dataService
      .putData(`${this.url}/${id}/contacted`, {})
      .subscribe((response) => {
        if (response.rst) {
          this.messageService.add(response.msg, 'info');
          this.getData();
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  markPublished(id: string): void {
    if (!confirm('¿Desea marcar este prospecto como publicado?')) {
      return;
    }
    this.dataService
      .putData(`${this.url}/${id}/published`, {})
      .subscribe((response) => {
        if (response.rst) {
          this.messageService.add(response.msg, 'info');
          this.getData();
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  deleteData(id: string): void {
    if (!confirm('¿Desea eliminar este prospecto?')) {
      return;
    }
    this.dataService
      .deleteData(`${this.url}/delete/${id}`)
      .subscribe((response) => {
        if (response.rst) {
          this.messageService.add(response.msg, 'info');
          this.getData();
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  filter() {
    const texto = this.searchText.trim().toLowerCase();
    if (!texto) {
      this.filteredData = [...this.data];
    } else {
      this.filteredData = this.data.filter((item) => {
        return (
          (item.prospectName &&
            item.prospectName.toLowerCase().includes(texto)) ||
          (item.domain && item.domain.toLowerCase().includes(texto)) ||
          (item.city && item.city.toLowerCase().includes(texto)) ||
          (item.prospectType && item.prospectType.toLowerCase().includes(texto))
        );
      });
    }
  }

  updateSuggestions() {
    const sugerenciasSet = new Set<string>();
    this.data.forEach((item) => {
      if (item.prospectName) sugerenciasSet.add(item.prospectName);
      if (item.domain) sugerenciasSet.add(item.domain);
    });
    this.searchSuggestions = Array.from(sugerenciasSet).filter(Boolean);
  }

  updateExecutionStatus(item: any, status: string): void {
    const body = { executionStatus: status };
    this.dataService
      .putData(`${this.url}/${item._id}/execution-status`, body)
      .subscribe((response) => {
        if (response.rst) {
          this.messageService.add(response.msg, 'info');
          this.getData();
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  updateExecutionType(item: any, type: string): void {
    if (!confirm(`¿Desea cambiar el tipo de ejecución a ${type}?`)) {
      return;
    }
    const body = { executionType: type };
    this.dataService
      .putData(`${this.url}/${item._id}/execution-type`, body)
      .subscribe((response) => {
        if (response.rst) {
          this.messageService.add(response.msg, 'info');
          this.getData();
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  // Wrappers for flow-specific buttons
  markReady(item: any) {
    this.updateExecutionStatus(item, 'ready');
  }
  markSubmitted(item: any) {
    this.updateExecutionStatus(item, 'submitted');
  }
  markPublishedExecution(item: any) {
    this.updateExecutionStatus(item, 'published');
  }
  markResearching(item: any) {
    this.updateExecutionStatus(item, 'researching');
  }
  markVerificationPending(item: any) {
    this.updateExecutionStatus(item, 'verification_pending');
  }
  markContactedExecution(item: any) {
    this.updateExecutionStatus(item, 'contacted');
  }
  markReplied(item: any) {
    this.updateExecutionStatus(item, 'replied');
  }
  markApprovedExecution(item: any) {
    this.updateExecutionStatus(item, 'approved');
  }

  openReviewModal(item: any) {
    // This would typically open a modal, for now we can alert or implement a simple type selection
    this.messageService.add(
      'Por favor, asigne un Tipo de Ejecución para este prospecto.',
      'warning',
    );
  }

  getExecutionTypeBadgeClass(type: string): string {
    switch (type) {
      case 'self_serve':
        return 'badge-primary';
      case 'claim':
        return 'badge-warning text-dark';
      case 'outreach':
        return 'badge-dark';
      case 'unknown':
        return 'badge-secondary';
      default:
        return 'badge-light';
    }
  }

  getExecutionStatusBadgeClass(status: string): string {
    switch (status) {
      case 'pending':
        return 'badge-secondary';
      case 'researching':
        return 'badge-info';
      case 'ready':
        return 'badge-primary';
      case 'submitted':
        return 'badge-info';
      case 'verification_pending':
        return 'badge-secondary';
      case 'contacted':
        return 'badge-primary';
      case 'replied':
        return 'badge-info';
      case 'approved':
        return 'badge-warning text-dark';
      case 'published':
        return 'badge-success';
      case 'rejected':
        return 'badge-danger';
      default:
        return 'badge-light';
    }
  }

  getStatusBadgeClass(status: string): string {
    switch (status) {
      case 'pending':
        return 'badge-secondary';
      case 'contacted':
        return 'badge-info';
      case 'replied':
        return 'badge-primary';
      case 'negotiating':
        return 'badge-warning';
      case 'approved':
        return 'badge-success';
      case 'rejected':
        return 'badge-danger';
      case 'published':
        return 'badge-dark';
      default:
        return 'badge-light';
    }
  }

  showModal(title: string, content: string) {
    this.modalTitle = title;
    this.modalContent = content;
  }

  closeModal() {
    this.modalContent = null;
  }
}
